module.exports = __webpack_public_path__ + "static/media/cog.a7f887e7.svg";